import { trackerInterface } from 'app-components/utils/core';
import mixpanel, { dynamicDefaultPropertiesCreator } from 'utils/core/mixpanel';
import { trackLaunchDarklyEvent } from './launchDarklyEvents';

trackerInterface.trackerInterfaceInit({
  track: (event, props) => {
    mixpanel.track(event, props);
    trackLaunchDarklyEvent(typeof window === 'undefined' ? undefined : window.ldClient, event, props);
  },
  identify: (userId) => mixpanel.identify(userId),
  getIdentity: () => mixpanel.get_distinct_id(),
  timeEvent: (event) => mixpanel.time_event(event),
  dynamicDefaultProperties: dynamicDefaultPropertiesCreator,
  updateProfile: (props) => mixpanel.people.set(props),
});
